import { Component } from '@angular/core';
declare let gtag: Function;
import { environment } from 'environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor() {
    window.onload = function(){ document.getElementById("nb-global-spinner").style.display = "none" }

  }

}
